import React, { useEffect, useState } from "react";
import { api } from "@/api/client.js";
import { PhotoLightbox } from "@/components/PhotoLightbox.jsx";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";

function isPhoto(item) {
  const kind = String(item?.kind || "photo").toLowerCase();
  return kind === "photo" || kind === "image";
}

export function PhotoGallery({ fallback = [] }) {
  const { ui } = useOrignalUi();
  const [items, setItems] = useState(null);
  const [index, setIndex] = useState(-1);

  useEffect(() => {
    api("/api/media")
      .then((body) => {
        const rows = (body.items || []).filter(isPhoto);
        setItems(rows.length ? rows : fallback.filter(isPhoto));
      })
      .catch(() => setItems(fallback.filter(isPhoto)));
  }, []);

  const shown = items || [];
  return (
    <div data-testid="photo-gallery">
      <p data-testid="photo-count">{items ? `${shown.length} photos` : ui.app.loading}</p>
      <div className="og-photo-grid">
        {shown.map((photo, i) => {
          const src = photo.thumb_url || photo.url || "";
          return (
            <button
              key={photo.id || i}
              type="button"
              className="og-photo-grid__shot"
              data-testid={`gallery-${photo.id}`}
              onClick={() => setIndex(i)}
            >
              {src ? (
                <img src={src} alt={photo.caption || photo.original_filename || ""} />
              ) : (
                <span>Fichier manquant</span>
              )}
            </button>
          );
        })}
      </div>
      {items && !shown.length ? <p className="og-hint">{ui.photos.empty}</p> : null}
      {index >= 0 ? (
        <PhotoLightbox items={shown} index={index} onIndex={setIndex} onClose={() => setIndex(-1)} ui={ui} />
      ) : null}
    </div>
  );
}
